type ServerItem = {
    key: string;
    value: string;
};

const SERVER_LIST = [
    { key: "fed", value: "fapi-eu0.febest.eu" },
    { key: "fbg", value: "fapi-eu0.febest.eu" },
    { key: "fac", value: "fapi-me0.febest.eu" },
    { key: "fae", value: "fapi-me0.febest.eu" },
    { key: "fkz", value: "fapi-kz0.febest.eu" },
    // { key: "fed", value: "fms-demo-kz.febest.dev" },
    // { key: "fbg", value: "fms-demo-kz.febest.dev" },
    // { key: "fac", value: "fms-demo-kz.febest.dev" },
    // { key: "fae", value: "fms-demo-kz.febest.dev" },
    // { key: "fkz", value: "fms-demo-kz.febest.dev" },
    // { key: "fed", value: "roman-core-fms-eu.febest.dev" },
    // { key: "fbg", value: "roman-core-fms-eu.febest.dev" },
    // { key: "fac", value: "roman-core-fms.febest.dev" },
    // { key: "fae", value: "roman-core-fms.febest.dev" },
    // { key: "fed", value: "roman-core-fms.febest.dev" },
    // { key: "fbg", value: "roman-core-fms.febest.dev" },
    // { key: "fkz", value: "roman-core-fms.febest.dev" },
] as const satisfies readonly ServerItem[];

type ServerKey = (typeof SERVER_LIST)[number]["key"];

type ServerList = {
    get(key: ServerKey): string;
    getNext(key: ServerKey): string;
    getDefault(): string;
    getListByKeys(keys: string[]): string[];
};

const serverMap: Record<ServerKey, string> = Object.fromEntries(
    SERVER_LIST.map(({ key, value }) => [key, value])
) as Record<ServerKey, string>;

const serverKeys = SERVER_LIST.map(({ key }) => key) as ServerKey[];

const isServerKey = (key: string): key is ServerKey => key in serverMap;

export const serverList: ServerList = {
    get(key: ServerKey): string {
        return serverMap[key];
    },

    getNext(key: ServerKey): string {
        const currentIndex = serverKeys.indexOf(key);
        const nextIndex = (currentIndex + 1) % serverKeys.length;
        return serverMap[serverKeys[nextIndex]];
    },

    getDefault(): string {
        return serverMap[serverKeys[0]];
    },

    getListByKeys(keys: string[]): string[] {
        const result: string[] = [];

        for (const key of keys) {
            if (!isServerKey(key)) {
                continue;
            }

            const server = serverMap[key];

            if (!result.includes(server)) {
                result.push(server);
            }
        }

        return result;
    }
};